export default __webpack_public_path__ + "static/media/CacheAcitve.76d26a49.svg";